/**
 * Created by shubham on 19/11/18.
 */

import { Component } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { HttpService } from '../../shared/services/http.service'
import { MdDialog } from '@angular/material';
import { CommonService } from '../../shared/services/common.service';
import { SessionHandler } from '../../shared/services/session-handler.service';
import { TranslateService } from 'ng2-translate';

@Component({
    template: require('./request-business-unit.component.html')
})

export class RequestBusinessUnitComponent {
    data: any = [];
    dialogRef;
    id: any;
    languageId: any;

    constructor(private router: Router, private route: ActivatedRoute, private httpService: HttpService,private sessionHandler:SessionHandler,
                public dialog: MdDialog,  private translate: TranslateService, private commonService: CommonService) {

        this.languageId = this.sessionHandler.getItem('languageId');
        if(!this.languageId){
            this.languageId = "EN";
        }
        this.translate.use(this.languageId);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/user-operations/request-business-unit/request-business-unit.component.ts